import { useItem } from "../../../fetch/fetch.item.ts";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item.ts";
const formatter = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  trailingZeroDisplay: "stripIfInteger",
} as Intl.NumberFormatOptions);
const ItemPrice = ({ id }: { id: string }) => {
  const { item, isLoading, isError } = useItem(id, EMPTY_ITEM);
  // Create our number formatter.

  if (isLoading) return "..€";
  if (isError) return isError;
  return formatter.format(item.price);
};
export default ItemPrice;
